import Home from "../views/Home";
import Category from "../views/Category";
import SubCategory from "../views/SubCategory";
import SubCategoryNew from "../views/SubCategory_new";
import ProductPopup from "../components/Popups/ProductPopup";
import Post from "../views/Post";
import Product from "../views/Product";
import Checkout from "../views/Checkout";
import MyAccount from "../views/MyAccount";
import AdminTools from "../views/AdminTools";
import Blog from "../views/Blog";

import OrderHistory from "../components/MyAccount/OrderHistory";
import Favorites from "../components/MyAccount/Favorites";
import PermenentOrder from "../components/MyAccount/PermenantOrder";
import Cashback from "../components/MyAccount/Cashback";
//import orderHistory from "../components/MyAccount/OrderHistory";
import OrderEnter from "../views/OrderEnter";
import Faq from "../views/Faq";
import OrderPay from "../views/OrderPay";
import Sales from "../views/Sales";
import Terms from "../views/Terms";
import Career from "../views/Career";
import Delivery from "../views/Delivery";
import ThankYou from "../views/ThankYou";
import CostumerService from "../views/CostumerService";
import About from "../views/About";
import PasswordReset from "../views/PasswordReset";
import B2bLeadForm from "../views/B2bLeadForm";
import store from "../store";
import PageNotFound from "../views/404";

// Gift card views
import GiftCardPurchase from "../views/GiftCard/Purchase.vue";
import GiftCardSend from "../views/GiftCard/Send.vue";
import GiftCardPay from "../views/GiftCard/Pay.vue";
import GiftCardThankYou from "../views/GiftCard/ThankYou.vue";
import GiftCardCompanies from "../views/GiftCard/Companies.vue";
// END OF: Gift card views

import UpsellPage from "../views/ProductRecommendations/Main.vue";

import { mapActions, mapGetters } from "vuex";
import vue from "vue";
let page_type = wpData.cat_page_type == "infinite" ? true : false;

const routes = [
	{
		path: "/",
		name: "home",
		component: Home,
		props: (route) => ({
			query: route.query.s,
		}),
	},
	{
		path: "/מתכונים/",
		name: "blog",
		component: Blog,
		children: [
			{
				path: "עמוד/:page",
				name: "blog-posts-main-page",
			},
			{
				path: "תגית/:tagSlug",
				name: "blog-posts-by-tag",
			},
			{
				path: "תגית/:tagSlug/עמוד/:page",
				name: "blog-posts-by-tag-page",
			},
			{
				path: "קטגוריה/:catSlug",
				name: "blog-posts-by-cat",
			},
			{
				path: "קטגוריה/:catSlug/עמוד/:page",
				name: "blog-posts-by-cat-page",
			},
		],
	},
	{
		path: "/%d7%9e%d7%aa%d7%9b%d7%95%d7%a0%d7%99%d7%9d/", // path: "/%D7%9E%D7%AA%D7%9B%D7%95%D7%A0%D7%99%D7%9D/",
		name: "blog",
		component: Blog,
		children: [
			{
				path: "%d7%a2%d7%9e%d7%95%d7%93/:page",
				name: "blog-posts-main-page",
			},
			{
				path: "%d7%aa%d7%92%d7%99%d7%aa/:tagSlug",
				name: "blog-posts-by-tag",
			},
			{
				path: "%d7%aa%d7%92%d7%99%d7%aa/:tagSlug/%d7%a2%d7%9e%d7%95%d7%93/:page",
				name: "blog-posts-by-tag-page",
			},
		],
	},
	{
		path: "/admin-tools/",
		name: "adminTools",
		component: AdminTools,
	},
	{
		path: "/product/:product/",
		component: Product,
		name: "product",
	},
	{
		path: "/product-category/:cat/:subcat/",
		component: page_type ? SubCategoryNew : Category,
		name: "subcategory",
	},
	{
		path: "/product-category/:cat/",
		name: "category",
		component: page_type ? SubCategoryNew : Category,
	},
	{
		path: "/order-enter/",
		name: "orderEnter",
		component: OrderEnter,
		props: true,
		beforeEnter: (to, from, next) => {
			next();
		},
	},
	{
		path: "/checkout/",
		name: "checkout",
		component: Checkout,
		beforeEnter: (to, from, next) => {
			next();
		},
		beforeMount() {
			this.$store.commit("changeCheckoutStage", "info");
		},
	},
	{
		path: "/checkout/order-pay/:orderId/",
		name: "orderPay",
		component: OrderPay,
		props: (route) => ({
			query: route.query.key,
		}),
	},
	{
		path: "/checkout/order-received/:orderId/",
		name: "thank-you",
		component: ThankYou,
		props: true,
		beforeEnter: (to, from, next) => {
			next();
		},
	},
	{
		path: "/checkout/:slug/",
		name: "checkout-permenent",
		component: Checkout,
		props: true,
		beforeEnter: (to, from, next) => {
			next();
		},
		beforeMount() {
			this.$store.commit("changeCheckoutStage", "info");
		},
	},
	{
		path: "/my-account/",
		name: "myaccount",
		component: MyAccount,
		beforeEnter: (to, from, next) => {
			if (store.state.userLoggedInfo) {
				next();
				return;
			}
			if (to.name == "favorites") {
				vue.prototype.$modal.show("login-modal", { state: "favs" });
			}
			if (to.name == "myaccount") {
				vue.prototype.$modal.show("login-modal", { state: "login" });
			}
			if (to.name == "cashback") {
				vue.prototype.$modal.show("login-modal", { state: "cashback" });
			}
			if (to.name == "history") {
				vue.prototype.$modal.show("login-modal", { state: "history" });
			} else {
				vue.prototype.$modal.show("login-modal", { state: "login" });
			}
			store.watch(
				(state) => state.userLogged,
				(value) => {
					console.debug("[router] ok store initialization state changed", value);
					if (value == true) next();
					return;
				}
			);
			next("/");
		},
		children: [
			{
				path: "",
				name: "userhome",
			},
			{
				path: "permenant",
				name: "permenent",
				component: PermenentOrder,
			},
			{
				path: "history",
				name: "history",
				component: OrderHistory,
			},
			{
				path: "favorites",
				name: "favorites",
				component: Favorites,
				props: true,
				pathToRegexOptions: {
					strict: true,
				},
				beforeEnter: (to, from, next) => {
					if (!store.state.userLogged) {
						vue.prototype.$modal.show("login-modal", {
							state: "favs",
						});
						store.watch(
							(state) => state.userLogged,
							(value) => {
								console.debug("[router] ok store initialization state changed", value);
								if (value == true) next();
							}
						);
					} else {
						next();
					}
				},
			},
			{
				path: "cashback",
				name: "cashback",
				component: Cashback,
			},
		],
	},
	{
		path: "/lost-password/",
		name: "lost-password",
		component: PasswordReset,
	},
	{
		path: "/product-recommendations/",
		name: "productRecommendations",
		component: UpsellPage,
	},
	{
		path: "/gift-card/purchase/",
		name: "giftCardPurchase",
		component: GiftCardPurchase,
	},
	{
		path: "/gift-card/send/",
		name: "giftCardSend",
		component: GiftCardSend,
	},
	{
		path: "/gift-card/pay/",
		name: "giftCardPay",
		component: GiftCardPay,
	},
	{
		path: "/gift-card/thank-you/:orderId/:orderKey/",
		name: "giftCardThankYou",
		component: GiftCardThankYou,
		props: true,
	},
	{
		path: "/gift-card/companies/",
		name: "giftCardCompanies",
		component: GiftCardCompanies,
	},
];
export default routes;
